import './PdfReportTypeSelection.css';

import React, { useState } from 'react';
import Box from '@mui/material/Box';
import PdfReportType from './PdfReportType';
import useB2BTranslation from '../../../b2b-common/hooks/useB2BTranslation';
import { generateClassName } from '../../../b2b-common/helpers';

const PdfReportTypeSelection = ({ onSelection, size = '100px', className=null }) => {
    const { t } = useB2BTranslation('b2b-reporting');
    const [selectedReport, setSelectedReport] = useState(null);

    const handleSelection = (reportType) => {
        setSelectedReport(reportType);
        if (onSelection) {
            onSelection(reportType);
        }
    };

    return (
        <Box display="flex" justifyContent="left" className={generateClassName('pdf-report-type-selection','', className)}>
            <PdfReportType
                alt={t('Back2Blu Standard Report')}
                src="/images/pdf-reporting/pdf-Standard.png"
                selected={selectedReport === 'report_standard'}
                size={size}
                label={t('Back2Blu Standard Report')}
                onClick={() => handleSelection('report_standard')}
            />
            <PdfReportType
                alt={t('AUE Report')}
                src="/images/pdf-reporting/pdf-AUE.png"
                selected={selectedReport === 'report_aue'}
                size={size}
                label={t('AUE Report')}
                onClick={() => handleSelection('report_aue')}
            />
            <PdfReportType
                alt={t('Agenda 2030 Report')}
                src="/images/pdf-reporting/pdf-A2030.png"
                selected={selectedReport === 'report_a2030'}
                size={size}
                label={t('Agenda 2030 Report')}
                onClick={() => handleSelection('report_a2030')}
            />
        </Box>
    );
};

export default PdfReportTypeSelection;